package or.garden.manager.features.notes.components

import androidx.compose.runtime.Composable
import or.garden.manager.domain.model.NoteData
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.dom.*
import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.px

private external fun setupQuill(element: Any, initialContent: String, onContentChange: (String) -> Unit): Any

@Composable
fun NoteEditView(
    selectedNote: NoteData?,
    noteTitle: String,
    onTitleChange: (String) -> Unit,
    noteContent: String,
    onContentChange: (String) -> Unit,
    isSaving: Boolean,
    onSave: () -> Unit,
    onBack: () -> Unit
) {
    Div({ classes("bg-white", "rounded-2xl", "p-8", "max-w-4xl", "mx-auto") }) {
        // Back Button
        Button({
            classes("flex", "items-center", "gap-2", "text-gray-500", "hover:text-emerald-600", "transition-colors", "mb-6")
            onClick { onBack() }
        }) {
            I({ classes("fas", "fa-arrow-left") })
            Text("Nazad")
        }

        H2({ classes("text-2xl", "font-bold", "text-gray-900", "mb-8") }) {
            Text(if (selectedNote == null) "Nova bilješka" else "Uredi bilješku")
        }

        Div({ classes("space-y-6") }) {
            // Naslov
            Div {
                Label(attrs = { classes("block", "text-sm", "font-medium", "text-gray-700", "mb-1") }) { Text("Naslov") }
                Input(
                    type = org.jetbrains.compose.web.attributes.InputType.Text,
                    attrs = {
                        classes("w-full", "px-4", "py-3", "rounded-xl", "border", "border-gray-200", "focus:ring-2", "focus:ring-emerald-500", "outline-none")
                        value(noteTitle)
                        onInput { onTitleChange(it.value) }
                        placeholder("Unesite naslov bilješke...")
                    }
                )
            }

            // Sadržaj
            Div {
                Label(attrs = { classes("block", "text-sm", "font-medium", "text-gray-700", "mb-1") }) { Text("Sadržaj") }

                Div({
                    classes("bg-white", "rounded-xl", "border", "border-gray-200", "focus-within:ring-2", "focus-within:ring-emerald-500", "outline-none", "overflow-hidden")
                }) {
                    Div({
                        style {
                            height(250.px)
                        }
                        ref { element ->
                            setupQuill(element, noteContent, onContentChange)
                            onDispose {
                                // Quill doesn't have a formal destroy, but we can clear the element
                                element.innerHTML = ""
                            }
                        }
                    })
                }
            }

            // Actions
            Div({ classes("flex", "justify-end", "gap-4", "pt-4") }) {
                Button({
                    classes("px-8", "py-3", "rounded-xl", "bg-emerald-600", "text-white", "font-bold", "hover:bg-emerald-700", "transition-colors", "disabled:opacity-50")
                    if (isSaving) disabled()
                    onClick { onSave() }
                }) {
                    if (isSaving) {
                        I({ classes("fas", "fa-spinner", "fa-spin", "mr-2") })
                    }
                    Text(if (selectedNote == null) "Sačuvaj" else "Ažuriraj")
                }
            }
        }
    }
}
